import React, {useEffect, useRef, useState} from 'react';
import {Card, CardContent} from '@mui/material';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import {COLORS} from '@/utils/constants';

interface Props {
	final: any[];
}

const CATEGORIES = [
	{name: 'Family & friends', question: 'question50'},
	{name: 'Business Angels', question: 'question55'},
	{name: 'Crowdfunding', question: 'question60'},
	{name: 'Incubators and Accelerators', question: 'question65'},
	{name: 'NGO’s loans', question: 'question70'},
	{name: 'NGO’s grants', question: 'question75'},
	{name: 'Public subsidies', question: 'question80'},
	{name: 'Public grants', question: 'question85'},
	{name: 'Venture capital', question: 'question90'},
	{name: 'Microfinance', question: 'question95'},
	{name: 'Financial institutions (banks)', question: 'question100'},
	{name: 'Other', question: 'question105'},
];

const FACTORS = [
	{name: 'Increased business modeling skills', value: 'Item 1', color: COLORS.e4ImpactBlue},
	{name: 'Increased business planning skills', value: 'Item 2', color: COLORS.orange},
	{name: 'Increased financial planning skills', value: 'Item 3', color: COLORS.gray},
	{name: 'Increased pitching skills', value: 'Item 4', color: COLORS.yellow},
	{name: 'E4Impact investors network', value: 'Item 5', color: COLORS.blue},
	{name: 'Other', value: 'other', color: COLORS.green},
];

const MainSuccessFactors = ({final}: Props) => {
	const chartComponentRef = useRef<HighchartsReact.RefObject>(null);
	const [options, setOptions] = useState<Highcharts.Options>();

	const calculateSubmissions = () => {
		const data: Record<string, Record<string, number>> = {};
		FACTORS.forEach((factor) => {
			data[factor.value] = {};
			CATEGORIES.forEach((category) => {
				data[factor.value][category.question] = 0;
			});
		});

		final.forEach((submission) => {
			CATEGORIES.forEach((category) => {
				const answers = Object.keys(submission)
					.filter((key) => key.startsWith(category.question))
					.map((key) => submission[key])
					.filter(Boolean);

				answers.forEach((answer) => {
					if (data[answer]) {
						data[answer][category.question] += 1;
					}
				});
			});
		});

		const series = FACTORS.map((factor) => ({
			type: 'bar' as const,
			name: factor.name,
			color: factor.color,
			data: CATEGORIES.map((category) => data[factor.value][category.question]),
		}));

		setOptions({
			chart: {type: 'bar'},
			title: {text: 'Main success factors', align: 'left'},
			xAxis: {categories: CATEGORIES.map((c) => c.name)},
			yAxis: {title: {text: null}},
			legend: {verticalAlign: 'bottom'},
			plotOptions: {
				bar: {
					stacking: undefined,
					dataLabels: {enabled: false}
				},
			},
			series,
		});
	};

	useEffect(() => {
		calculateSubmissions();
	}, [final]);

	return (
		<Card className='chart-container'>
			<CardContent>
				{options && <HighchartsReact highcharts={Highcharts} options={options} ref={chartComponentRef} />}
			</CardContent>
		</Card>
	);
};

export default MainSuccessFactors;